<template>
  <HorizontalScrollWithIndicator v-slot="{ scroll }">
    <FloatingContainer>
      <slot :scroll="scroll" />
    </FloatingContainer>
  </HorizontalScrollWithIndicator>
</template>

<script setup>
import HorizontalScrollWithIndicator from '@/components/Containers/HorizontalScrollWithIndicator.vue'
import FloatingContainer from '@/components/Containers/FloatingContainer.vue'
</script>
